import * as React from 'react';
import { change } from 'redux-form';
import { path } from 'ramda';

export const useNullifyDependentFields = ({ dispatch, formValues }) => {
  const nullify = dkey => dispatch(change('msLifestyle', dkey, null));

  const { diet, smoking, snus, alcoholUse, usingOtherSubstances, otherSubstancesUsingOther } = formValues;

  const dependentFields = {
    diet: ['specialDiet', 'vegetarianSince', 'eggsAndMilk', 'allergy'],
    smoking: ['smokingStartYear', 'cigarettesADay', 'smokingEndYear'],
    snus: ['snusStartYear', 'snusPortionsADay', 'snusEndYear'],
    alcoholUse: ['alcoholMoreThan6Interval'],
    usingOtherSubstances: [
      'otherSubstanceMarijuanaUsageInterval',
      'otherSubstancesUsingOther',
      'otherSubstanceOtherName',
      'otherSubstanceOtherUsageInterval',
    ],
    otherSubstancesUsingOther: ['otherSubstanceOtherName', 'otherSubstanceOtherUsageInterval'],
  };

  React.useEffect(() => {
    Object.keys(dependentFields).forEach(key => {
      const value = path(key.split('.'), formValues);
      if (!value) return;

      dependentFields[key].forEach(dkey => {
        const dvalue = path(dkey.split('.'), formValues);
        if (!dvalue) return;

        switch (dkey) {
          /** diet */
          case 'specialDiet': {
            if (!value.includes('otherDiet')) nullify(dkey);
            break;
          }
          case 'vegetarianSince':
          case 'eggsAndMilk': {
            if (!value.includes('vege')) nullify(dkey);
            break;
          }
          case 'allergy': {
            if (!value.includes('foodAllergy')) nullify(dkey);
            break;
          }
          /** smoking */
          case 'smokingStartYear':
          case 'cigarettesADay': {
            if (!['yes', 'smokedBefore'].includes(value)) nullify(dkey);
            break;
          }
          case 'smokingEndYear': {
            if (value !== 'smokedBefore') nullify(dkey);
            break;
          }
          /** snus */
          case 'snusStartYear':
          case 'snusPortionsADay': {
            if (!['yes', 'snusedBefore'].includes(value)) nullify(dkey);
            break;
          }
          case 'snusEndYear': {
            if (value !== 'snusedBefore') nullify(dkey);
            break;
          }
          /** alcoholUse */
          case 'alcoholMoreThan6Interval': {
            if (!['month', '43month', '23week', '4orMoreOften'].includes(value)) nullify(dkey);
            break;
          }
          /** usingOtherSubstances */
          /** otherSubstancesUsingOther */
          case 'otherSubstanceMarijuanaUsageInterval':
          case 'otherSubstancesUsingOther':
          case 'otherSubstanceOtherName':
          case 'otherSubstanceOtherUsageInterval': {
            if (value !== 'yes') nullify(dkey);
            break;
          }
          /** default */
          default: {
            nullify(dkey);
            break;
          }
        }
      });
    });
  }, [diet, smoking, snus, alcoholUse, usingOtherSubstances, otherSubstancesUsingOther]);
};
